import { Component, ViewChild } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { HistoryService } from 'app/core/history.service';
import { Dealer } from 'app/core/model/dealer';
import { DeliveryDriver } from 'app/core/model/delivery-driver';
import { DeliveryTrailer } from 'app/core/model/delivery-trailer';
import { DeliveryTruck } from 'app/core/model/delivery-truck';
import { DeliveryTransportPlate } from 'app/core/model/delivery-transport-plate';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { Delivery } from 'app/core/model/delivery';

@Component({
    selector: 'app-delivery-history',
    templateUrl: './delivery-history.component.html',
    styleUrls: ['./delivery-history.component.scss'],
    standalone: false
})
export class DeliveryHistoryComponent {
    filter: any;
    deliveries: any[];
    dealers: Dealer[];
    drivers: DeliveryDriver[];
    trucks: DeliveryTruck[];
    trailers: DeliveryTrailer[];
    transportPlates: DeliveryTransportPlate[];

    openedDelivery: Delivery;
    showStackFlyout: boolean;
    isFlyoutReadOnly: boolean;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private sessionInfo: SessionInformationService, private appInfo: AppInformationService, private historyService: HistoryService) {}

    async ngOnInit() {
        this.dealers = await this.uow.getDealers();
        this.drivers = (await this.uow.deliveryDrivers.whereActive('displayOrder, name')) as DeliveryDriver[];
        this.trucks = (await this.uow.deliveryTrucks.whereActive('displayOrder, name')) as DeliveryTruck[];
        this.trailers = (await this.uow.deliveryTrailers.whereActive('displayOrder, name')) as DeliveryTrailer[];
        this.transportPlates = (await this.uow.deliveryTransportPlates.whereActive('displayOrder, name')) as DeliveryTransportPlate[];
        const filter = this.sessionInfo.getItem('delivery-history-filter');
        if (filter) {
            this.filter = filter;
            await this.search();
        } else this.filter = { includeDeleted: false };
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        this.deliveries = await this.historyService.getDeliveryHistory(this.filter);
        this.sessionInfo.setItem('delivery-history-filter', this.filter);
        this.appInfo.pleaseWaitHide();
    }

    async unComplete(mode?: string) {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        const result = await confirm(`Are you sure you want to UnComplete?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const delivery = (await this.uow.deliveries.byId(selectedRow.id)) as Delivery;
        if (mode === 'delivery') {
            delivery.completed = null;
            delivery.completedBy = null;
        } else {
            delivery.stackCompleted = null;
            delivery.stackCompletedBy = null;
        }
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
        this.search();
    }

    clear() {
        this.filter = { includeDeleted: false };
        this.closeStack();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async openStack(selectedRow: any) {
        if (!selectedRow) return;
        this.openedDelivery = (await this.uow.deliveries.byId(selectedRow.id, 'deliveryStacks.orderLineDetail.orderLine.order.dealer')) as Delivery;
        this.isFlyoutReadOnly = !!this.openedDelivery.completed;
        this.showStackFlyout = true;
    }

    closeStack() {
        this.showStackFlyout = false;
        this.openedDelivery = null;
    }
}
